module.exports = __webpack_public_path__ + "img/bottom_allow.bd8f5b2a.svg";